<template>
  <div>
    <h3>Bonificación diaria</h3>
    <p>El bono por el primer depósito diario se acredita diariamente por un monto equivalente al {{bonus.percent}}% de la suma depositada.</p>
    <p>Cada bono se otorga bajo determinadas condiciones y determinadas restricciones que deben ser cumplidas para tener la posibilidad de retirar de la cuenta los fondos de bonificación. Según el tipo de bonificación ofrecida, es posible que se le solicite que cumpla ciertas condiciones para obtener la posibilidad de retirar de la cuenta los resultados positivos de la apuesta, logrados utilizando la bonificación.</p>
    <h5>Orden de acreditación del bono</h5>
    <ol>
      <li>Recarga tu saldo.</li>
      <li>El bono se acredita automáticamente después de recargar el saldo, con la condición de que al momento de ello el jugador no tenga otros bonos activos</li>
    </ol>

    <h5>Reglas y condiciones</h5>
    <ol>
      <li>El usuario tiene derecho a recibir solamente 1 bono por día.</li>
      <li>El bono se acredita automáticamente después de la primera recarga de la cuenta, siempre y cuando el jugador no tenga otros bonos activos en ese momento.</li>
      <li>Antes de cumplir las condiciones para recuperar lo apostado, no es posible retirar dinero en efectivo.</li>
      <li>
        Condiciones de recuperación de lo apostado
        <ul>
          <li v-if="redPipe">
            Casino: {{redPipe.contributionPercent}}% de cada apuesta que no exceda los
            <template v-for="cs in redPipe.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} para {{cs.currency}},
            </template>
          </li>
          <li v-if="flg">
            Juegos Live: {{flg.contributionPercent}}% de cada apuesta que no exceda los
            <template v-for="cs in flg.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} para {{cs.currency}},
            </template>
          </li>
          <li v-if="bk">
            Deporte: {{bk.contributionPercent}}% de cada apuesta que no exceda los 
            <template v-for="cs in bk.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} para {{cs.currency}},
            </template>
            con un coeficiente >= {{bk.minFactor}}
          </li>
          <li v-if="hdRaces">
            Deporte Virtual: {{hdRaces.contributionPercent}}% de cada apuesta
            <template v-for="cs in hdRaces.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} para {{cs.currency}},
            </template>
            con un coeficiente >= {{hdRaces.minFactor}}
          </li>
        </ul>
      </li>
      <li>La oferta no puede ser utilizada en combinación con otras promociones u ofertas especiales.</li>
      <li>Solo un bono disponible para un usuario, por familia, una dirección, una computadora compartida, una dirección IP común, para cualquier tipo de datos iguales de cuenta, como ser la dirección de correo electrónico, la cuenta bancaria, información de la tarjeta de crédito, cuenta del sistema de pago. Cualquier violación de las reglas del programa de bonificación derivará en el cierre de la cuenta.</li>
      <li>La bonificación recuperada se transfiere a la cuenta principal por el importe del saldo de los fondos de bonificación, pero no más del {{bonus.convertToRealMaxPercent}}% del valor de la bonificación inicial.</li>
      <li>Al retirar dinero en efectivo la bonificación se anula.</li>
      <li>Las reglas de la promoción pueden ser modificadas</li>
    </ol>
  </div>
</template>
<script>
  import Vue from "vue";

  export default {
    name: 'bonus-rules-deposit-es',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
          redPipe: null,
          flg: null,
          bk: null,
          hdRaces: null
      }
    },
    computed: {
      currency() {
        let player = Vue.state.player.get();
        return player && player.balance && player.balance.currency;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.redPipe = this.bonus.providers.filter(p => p.provider == 'redpipe')[0];
        this.flg = this.bonus.providers.filter(p => p.provider == 'flg')[0];
        this.bk = this.bonus.providers.filter(p => p.provider == 'bk')[0];
        this.hdRaces = this.bonus.providers.filter(p => p.provider == 'hdraces')[0];
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/es.vue